import { BaseItemStore } from "../../../core/BaseStore";
import type { BusinessCustomerMailModel } from "./BusinessCustomerMailModel";

export default class BusinessCustomerMailsStore extends BaseItemStore<BusinessCustomerMailModel> {}
